// extracted by mini-css-extract-plugin
export var card = "_le-5";
export var cardSelected = "_le-4";
export var image = "_le-3";
export var modal = "_le-0";
export var modalContent = "_le-1";
export var table = "_le-2";